import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const SearchPage = lazy(() => import('./SearchPage'));

// every signed-in user may search; the API only returns record types their role can read
const routes: RouteObject[] = [{ path: '/search', element: <SearchPage /> }];
export default routes;
